import {
    SEND_CONTACT_MESSAGE,
    SEND_CONTACT_MESSAGE_FAILED,
    RESET_FORMS
} from '../actions/types'

const initialState = {}

const contactReducer = (state = initialState, action) => {
    switch (action.type) {
        case SEND_CONTACT_MESSAGE:
            return {
                success: action.payload
            }
        case SEND_CONTACT_MESSAGE_FAILED:
            return {
                errors: action.payload
            }
        case RESET_FORMS:
            return initialState
        default:
            return state
    }
}

export default contactReducer